export default __webpack_public_path__ + "static/media/color-american-express.65a124f8.svg";